import { DatasetOption } from 'echarts/types/dist/shared';

import { DatasetBase, ReportsEChartsOption } from '@core/reports-types';

import { categoryNameFormatter } from '../formatter';
import { getXAxisNameLabel } from '../get-x-axis-name-label';

export const addXAxisNameLabel =
  (text: string) =>
  <T extends ReportsEChartsOption>(opts: T): T & { graphic: ReportsEChartsOption['graphic'] } => ({
    ...opts,
    graphic: [
      ...(Array.isArray(opts.graphic) ? opts.graphic : [opts.graphic ?? void 0]),
      getXAxisNameLabel(text),
    ],
  });

export const addXAxisTypeValue = <T extends {}>(opts: T) =>
  ({
    ...opts,
    xAxis: {
      minInterval: 1,
      boundaryGap: [0, '5%'],
      type: <const>'value',
    },
  }) satisfies ReportsEChartsOption;

export const addYAxisCategory =
  (dataset: DatasetBase) =>
  <T extends { dataset: DatasetOption }>(opts: T) =>
    ({
      ...opts,
      yAxis: {
        inverse: true,
        zlevel: 1,
        type: <const>'category',
        axisLabel: {
          show: true,
          formatter: categoryNameFormatter(dataset),
        },
      },
    }) satisfies ReportsEChartsOption;

export const addYAxisCategoryTruncate = <
  T extends {
    yAxis: {
      type: 'category';
    };
  },
>(
  opts: T,
) => ({
  ...opts,
  yAxis: {
    ...opts.yAxis,
    overflow: 'truncate',
    width: 150,
  },
});
